import React, { useState } from 'react';
import { Menu, Label, Icon, Message, Dropdown, Button} from 'semantic-ui-react';


/**
 * =========================================
 * 1. FILTER SCHEMA (SOURCE OF TRUTH)
 * =========================================
 */
const FILTER_SCHEMA = {
  gender: [
    { value: "m", label: "Male" },
    { value: "f", label: "Female" }
  ],

  vocal_chamber_music: [
    { value: "true", label: "True" }
  ],

  vocal_chamber_music_cycle: [
    { value: "true", label: "True" }
  ],


  composer_gender: [
    { value: "m", label: "Male" },
    { value: "f", label: "Female" }
  ],

  language: [
    { value: "english", label: "English" },
    { value: "spanish", label: "Spanish" },
    { value: "italian", label: "Italian" },
    { value: "french", label: "French" },
    { value: "german", label: "German" },
    { value: "hungarian", label: "Hungarian" },
    { value: "portuguese", label: "Portuguese" },
    { value: "russian", label: "Russian" }
  ], 

  voice_type: [
    { value: "1", label: "Baritone" },
    { value: "2", label: "Bass" },
    { value: "3", label: "Bass-Baritone" },
    { value: "4", label: "Bass-Barritone" },
    { value: "5", label: "Contralto" },
    { value: "6", label: "Female Voice" },
    { value: "7", label: "High Voice" },
    { value: "8", label: "Low Voice" },
    { value: "9", label: "Male Voice" },
    { value: "10", label: "Medium-High Voice" },
    { value: "11", label: "Medium Voice" },
    { value: "12", label: "Mezzo-Soprano" },
    { value: "13", label: "Not Indicated" },
    { value: "14", label: "Soprano" },
    { value: "15", label: "Spoken Female Voice" },
    { value: "16", label: "Spoken Voice" },
    { value: "17", label: "Voice" },
    { value: "18", label: "Tenor" },
    { value: "19", label: "Boy Soprano" },
    { value: "20", label: "Countertenor" },
    { value: "21", label: "Medium-Low Voice" },
    { value: "22", label: "Alto" },
    { value: "23", label: "Treble Voice" }
  ], 

  instrumentation: [
    { value: "1", label: "unaccompanied" },
    { value: "2", label: "piccolo" },
    { value: "3", label: "flute" },
    { value: "4", label: "flute/piccolo" },
    { value: "5", label: "flute/alto flute" },
    { value: "6", label: "flute/piccolo/alto flute" },
    { value: "7", label: "alto flute" },
    { value: "8", label: "tenor flute" },
    { value: "9", label: "bass flute" },
    { value: "10", label: "oboe" },
    { value: "11", label: "clarinet" },
    { value: "12", label: "alto clarinet" },
    { value: "13", label: "clarinet/bass clarinet" },
    { value: "14", label: "alto clarinet/bass clarinet/contrabass clarinet" },
    { value: "15", label: "clarinet in a" },
    { value: "16", label: "e_ clarinet" },
    { value: "17", label: "bass clarinet" },
    { value: "18", label: "saxophone" },
    { value: "19", label: "soprano saxophone" },
    { value: "20", label: "alto saxophone" },
    { value: "21", label: "tenor saxophone" },
    { value: "22", label: "baritone saxophone" },
    { value: "23", label: "bassoon" },
    { value: "24", label: "english horn" },
    { value: "25", label: "recorder" },
    { value: "26", label: "soprano recorder" },
    { value: "27", label: "alto recorder" },
    { value: "28", label: "bass recorder" },
    { value: "29", label: "piccolo trumpet" },
    { value: "30", label: "e_ trumpet" },
    { value: "31", label: "c trumpet" },
    { value: "32", label: "trumpet" },
    { value: "33", label: "cornet" },
    { value: "34", label: "bugle" },
    { value: "35", label: "flugelhorn" },
    { value: "36", label: "horn" },
    { value: "37", label: "trombone" },
    { value: "38", label: "tenor trombone" },
    { value: "39", label: "bass trombone" },
    { value: "40", label: "double bass trombone" },
    { value: "41", label: "baritone horn" },
    { value: "42", label: "euphonium" },
    { value: "43", label: "tuba" },
    { value: "44", label: "violin" },
    { value: "45", label: "viola" },
    { value: "46", label: "cello" },
    { value: "47", label: "double bass" },
    { value: "48", label: "treble viola da gamba" },
    { value: "49", label: "alto viola da gamba" },
    { value: "50", label: "tenor viola da gamba" },
    { value: "51", label: "bass viola da gamba" },
    { value: "52", label: "viola d'amore" },
    { value: "53", label: "banjo" },
    { value: "54", label: "cimbalom" },
    { value: "55", label: "guitar" },
    { value: "56", label: "harp" },
    { value: "57", label: "lute" },
    { value: "58", label: "mandolin" },
    { value: "59", label: "accordion" },
    { value: "60", label: "celesta" },
    { value: "61", label: "clavichord" },
    { value: "62", label: "continuo" },
    { value: "63", label: "harpsichord" },
    { value: "64", label: "amplified harpsichord" },
    { value: "65", label: "organ" },
    { value: "66", label: "piano" },
    { value: "67", label: "2 pianos" },
    { value: "68", label: "piano four-hands" },
    { value: "69", label: "child pianist" },
    { value: "70", label: "interior piano" },
    { value: "71", label: "prepared piano" },
    { value: "72", label: "toy piano" },
    { value: "73", label: "amplified piano" },
    { value: "74", label: "keyboard" },
    { value: "75", label: "synthesizer" },
    { value: "76", label: "percussion" },
    { value: "77", label: "cymbals" },
    { value: "78", label: "triangle" },
    { value: "79", label: "castanets" },
    { value: "80", label: "cowbell" },
    { value: "81", label: "claves" },
    { value: "82", label: "conga" },
    { value: "83", label: "crotales" },
    { value: "84", label: "drum" },
    { value: "85", label: "snare drum" },
    { value: "86", label: "tenor drum" },
    { value: "87", label: "finger cymbals" },
    { value: "88", label: "hand-held percussion" },
    { value: "89", label: "tambourine" },
    { value: "90", label: "timpani" },
    { value: "91", label: "glockenspiel" },
    { value: "92", label: "chimes" },
    { value: "93", label: "bells" },
    { value: "94", label: "glass harmonica" },
    { value: "95", label: "marimba" },
    { value: "96", label: "vibraphone" },
    { value: "97", label: "xylophone" },
    { value: "98", label: "electirc violin" },
    { value: "99", label: "electric cello" },
    { value: "100", label: "electric bass" },
    { value: "101", label: "electric guitar" },
    { value: "102", label: "electric piano" },
    { value: "103", label: "theremin" },
    { value: "104", label: "tape" },
    { value: "105", label: "prerecorded sound" },
    { value: "106", label: "audio collage" },
    { value: "107", label: "electronic sound" },
    { value: "108", label: "electronics" },
    { value: "109", label: "sound technician (with reverberation plate)" },
    { value: "110", label: "eskimo drum" },
    { value: "111", label: "gamelan" },
    { value: "112", label: "glass armonica" },
    { value: "113", label: "khaen" },
    { value: "114", label: "shakuhachi" },
    { value: "115", label: "sho" },
    { value: "116", label: "hardanger fiddle" },
    { value: "117", label: "dulcimer" },
    { value: "118", label: "harmonica" },
    { value: "119", label: "<instrument> (ad. lib.)" },
    { value: "120", label: "<instrument> (optional)" },
    { value: "121", label: "<instrument> (with electronic delay)" },
    { value: "122", label: "a melody instrument" },
    { value: "123", label: "player" },
    { value: "124", label: "chamber ensemble" },
    { value: "125", label: "chamber ensemble (instrumentation unknown)" },
    { value: "126", label: "orchestra" },
    { value: "127", label: "strings" },
    { value: "128", label: "percussion quartet" },
    { value: "129", label: "string orchestra" },
    { value: "130", label: "wind ensemble" },
    { value: "131", label: "concert band" },
    { value: "132", label: "clarinet trio" },
    { value: "133", label: "saxophone quartet" },
    { value: "134", label: "woodwind trio" },
    { value: "135", label: "woodwind quintet" },
    { value: "136", label: "piano trio" },
    { value: "137", label: "piano quartet" },
    { value: "138", label: "piano quintet" },
    { value: "139", label: "string trio" },
    { value: "140", label: "string quartet" },
    { value: "141", label: "string quintet" },
    { value: "142", label: "b_ clarinet" },
    { value: "143", label: "contrabass clarinet" },
    { value: "144", label: "chamber orchestra" },
    { value: "145", label: "tenor horn" },
    { value: "146", label: "suspended cymbals" }
  ]

};

// defining date fields 
const DATE_FIELDS = [
  'composer_birth_date',
  'composer_death_date',
  'composition_date', 
  'birth_date', 
  'death_date'
];

/**
 * =========================================
 * 2. TOGGLE MULTI-SELECT VALUES
 * =========================================
 */
function toggleValue(prev = {}, key, value) {
  const current = Array.isArray(prev[key]) ? [...prev[key]] : [];

  const exists = current.includes(value);

  const nextValues = exists
    ? current.filter(v => v !== value)
    : [...current, value];

  return {
    ...prev,
    [key]: nextValues.length ? nextValues : undefined
  };
}

/**
 * =========================================
 * 3. DATE HELPERS
 * =========================================
 */
function toYear(v) {
  if (!v && v !== 0) return null;
  const d = new Date(v);
  const y = d.getUTCFullYear();
  return isNaN(y) ? null : y;
}

function getRange(buckets = []) {
  const years = buckets
    .map(b => toYear(b.key_as_string || b.key))
    .filter(Boolean);

  if (!years.length) return [1800, 2026];

  return [Math.min(...years), Math.max(...years)];
}

function isDateHistogram(buckets = []) {
  if (!buckets.length) return false;
  return !isNaN(toYear(buckets[0].key_as_string || buckets[0].key));
}

/**
 * =========================================
 * 4. SERIALIZER (🔥 FIX FOR YOUR BUG)
 * =========================================
 * Keeps backend format: "1700-1850"
 */
export function buildQueryParams(optAggs = {}) {
  const params = new URLSearchParams();

  Object.entries(optAggs).forEach(([key, value]) => {

    // DATE RANGE → "1700-1850"
    if (
      value &&
      typeof value === "object" &&
      value.gte != null &&
      value.lte != null
    ) {
      params.append(key, `${value.gte}-${value.lte}`);
      return;
    }

    // ARRAY FILTERS (categorical)
    if (Array.isArray(value)) {
      value.forEach(v => params.append(key, v));
      return;
    }

    // fallback
    params.append(key, value);
  });

  return params;
}

/**
 * =========================================
 * 5. MAIN COMPONENT
 * =========================================
 */
export const Filters = ({ aggs, optAggs, setOptAggs, filterError }) => {
  const [openSections, setOpenSections] = useState({});

  if (!aggs) return null;

  const getBucketMap = (buckets = []) => {
    const map = new Map();

    if (Array.isArray(buckets)) {
      buckets.forEach(b => {
        map.set(b.key_as_string ?? b.key, b.doc_count);
      });
    } else {
      Object.entries(buckets).forEach(([key, bucket]) => {
        map.set(key, bucket.doc_count);
      });
    }

    return map;
  };

  const toggleSection = (name) => {
    setOpenSections(prev => ({
      ...prev,
      [name]: !prev[name]
    }));
  };

  const sections = Object.keys(aggs)
    .map(k => ({
      key: k,
      name: k.replace(/\W+|_+/g, ' ').trim(),
      data: aggs[k]
    }))
    .sort((a, b) => a.name.localeCompare(b.name));

  return (
    <Menu vertical secondary fluid>
      <Menu.Item> 
        <Button
          fluid
          basic
          onClick={() => setOptAggs({})}
        >
          Reset Filters
        </Button>
      </Menu.Item>
      
      <Menu.Item header>Filters</Menu.Item>

      {sections.map((section, i) => {

        const fieldKey = section.name
          .toLowerCase()
          .replace(/\s+/g, '_');

        const buckets = section.data?.buckets || [];
        const schema = FILTER_SCHEMA[fieldKey]; 
        const isDateField = DATE_FIELDS.includes(fieldKey);
        const isOpen = openSections[section.name];

        const bucketMap = getBucketMap(buckets);

        /**
         * =========================
         * DATE RANGE MODE (INPUT BOXES)
         * =========================
         */
        if (!schema && isDateField) {

          const range = getRange(buckets);

          const active = optAggs?.[fieldKey]?.gte != null
            ? {
                gte: optAggs[fieldKey].gte,
                lte: optAggs[fieldKey].lte
              }
            : {
                gte: range[0],
                lte: range[1]
              };

          return (
            <Menu.Item key={i}>
              <div
                onClick={() => toggleSection(section.name)}
                style={{
                  fontWeight: 600,
                  cursor: "pointer",
                  display: "flex",
                  justifyContent: "space-between"
                }}
              >
                {section.name}
                <Icon name={isOpen ? "chevron up" : "chevron down"} />
              </div>

              {isOpen && (
                <div style={{ padding: "10px 5px", display: "flex", flexDirection: "column", gap: 8 }}>

                  {/* START YEAR */}
                  <input
                    type="number"
                    placeholder="Start year"
                    value={active.gte}
                    onChange={(e) => {
                      const val = Number(e.target.value);
                      if (isNaN(val)) return;

                      setOptAggs(prev => ({
                        ...(prev || {}),
                        [fieldKey]: {
                          ...(prev?.[fieldKey] || {}),
                          gte: val
                        }
                      }));
                    }}
                    style={{
                      padding: "6px 8px",
                      border: "1px solid #ddd",
                      borderRadius: 4
                    }}
                  />

                  {/* END YEAR */}
                  <input
                    type="number"
                    placeholder="End year"
                    value={active.lte}
                    onChange={(e) => {
                      const val = Number(e.target.value);
                      if (isNaN(val)) return;

                      setOptAggs(prev => ({
                        ...(prev || {}),
                        [fieldKey]: {
                          ...(prev?.[fieldKey] || {}),
                          lte: val
                        }
                      }));
                    }}
                    style={{
                      padding: "6px 8px",
                      border: "1px solid #ddd",
                      borderRadius: 4
                    }}
                  />

                  <div style={{ fontSize: 12, marginTop: 4 }}>
                    {active.gte} → {active.lte}
                  </div>

                  <div>
                  {filterError && (
                    <Message negative size="small">
                      {filterError}
                    </Message>
                  )}
                  </div>

                </div>
              )}
            </Menu.Item>
          );
        }

        /**
         * =========================
         * NORMAL SCHEMA FILTERS
         * =========================
         */

        if (!schema) return null;

        const activeValues = optAggs?.[fieldKey] || [];

        const dropdownOptions = schema.map(opt => {
          const count = bucketMap.get(opt.value) || 0;

          return {
            key: opt.value,
            value: opt.value,
            text: (
              <span>
                {opt.label}
                <Label horizontal basic size="mini" style={{ marginLeft: 8 }}>
                  <Icon name="file" />
                  {count}
                </Label>
              </span>
            )
          };
        });

        return (
          <Menu.Item key={i}>

            <div
              onClick={() => toggleSection(section.name)}
              style={{
                fontWeight: 600,
                cursor: "pointer",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center"
              }}
            >
              {section.name}
              <Icon name={isOpen ? "chevron up" : "chevron down"} />
            </div>


            {isOpen && (
              <div style={{ marginTop: 8 }}>

                {fieldKey === "voice_type" || fieldKey === "instrumentation" ? (
                  <Dropdown
                    placeholder= {"Select " + fieldKey.split("_").map((word) => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")}
                    fluid
                    multiple
                    selection
                    options={dropdownOptions}
                    value={Array.isArray(activeValues) ? activeValues : []}
                    onChange={(e, { value }) => {
                      setOptAggs(prev => ({
                        ...(prev || {}),
                        [fieldKey]: value.length ? value : undefined
                      }));
                    }}
                  />
                ) : (
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 6
                    }}
                  >
                    {schema.map(opt => {

                      const isActive = Array.isArray(activeValues)
                        ? activeValues.includes(opt.value)
                        : activeValues === opt.value;

                      const count = bucketMap.get(opt.value) || 0;

                      return (
                        <button
                          key={opt.value}
                          onClick={() => {
                            const next = toggleValue(
                              optAggs || {},
                              fieldKey,
                              opt.value
                            );

                            setOptAggs(next);
                          }}
                          style={{
                            padding: "6px 10px",
                            borderRadius: 6,
                            border: "1px solid #ddd",
                            background: isActive ? "#2185d0" : "white",
                            color: isActive ? "white" : "black",
                            cursor: "pointer",
                            textAlign: "left"
                          }}
                        >
                          {opt.label}

                          <Label
                            horizontal
                            basic
                            size="mini"
                            style={{ marginLeft: 8 }}
                          >
                            <Icon name="file" />
                            {count}
                          </Label>
                        </button>
                      );
                    })}
                  </div>
                )}

              </div>
            )}

          </Menu.Item>
        );
      })}

    </Menu>
  );
};